import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type { User } from '../../types'
import { UserRoleEnum } from '../../types'

interface OnlineStatus {
    id: 1
    lastSeen: '2025-05-14T12:33:32.821Z'
    status: 'online'
}

interface AppState {
    onlineUsers: OnlineStatus[]
}

const initialState: AppState = {
    onlineUsers: [],
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        addOnlineUser(state, action: PayloadAction<OnlineStatus>) {
            const existedIndex = state.onlineUsers.findIndex(
                (user) => user.id === action.payload.id,
            )
            if (existedIndex > -1) {
                state.onlineUsers[existedIndex] = action.payload
            } else {
                state.onlineUsers.push(action.payload)
            }
        },
    },
})

export const { addOnlineUser } = appSlice.actions
export default appSlice.reducer
